<template>
	<div class="vx-row" v-if="objectDetail">
		<div class="vx-col w-full">
			<transition name="slide-fade">
				<vx-card class="overflow-hidden" no-shadow>
					<div slot="no-body">
						<table style="width: 100%" class="border-collapse">
							<caption></caption>
							<tr>
								<th class="p-2 border border-solid d-theme-border-grey-light font-bold text-lg">
									{{ $t("Information") }}
								</th>
								<th class="p-2 border border-solid d-theme-border-grey-light font-bold text-lg">
									{{ $t("UploadFiles.Details") }}
								</th>
							</tr>
							<tr>
								<td class="p-2 border border-solid d-theme-border-grey-light font-semibold">
									{{ $t("Routing.Table.Identification") }}
								</td>
								<td class="p-2 border border-solid d-theme-border-grey-light">
									{{ objectDetail.identification }}
								</td>
							</tr>
							<tr>
								<td class="p-2 border border-solid d-theme-border-grey-light font-semibold">
									{{ $t("CompanyCreate.InitDate") }}
								</td>
								<td class="p-2 border border-solid d-theme-border-grey-light">
									{{ objectDetail.time_window_repeat.init_date }}
								</td>
							</tr>
							<tr>
								<td class="p-2 border border-solid d-theme-border-grey-light font-semibold">
									{{ $t("CompanyCreate.EndDate") }}
								</td>
								<td class="p-2 border border-solid d-theme-border-grey-light">
									{{ objectDetail.time_window_repeat.end_date }}
								</td>
							</tr>
							<tr>
								<td class="p-2 border border-solid d-theme-border-grey-light font-semibold">
									{{ $t("Routing.Table.InitHour") }}
								</td>
								<td class="p-2 border border-solid d-theme-border-grey-light">
									{{ objectDetail.time_window_repeat.init_hour }}
								</td>
							</tr>
							<tr>
								<td class="p-2 border border-solid d-theme-border-grey-light font-semibold">
									{{ $t("Routing.Table.EndHour") }}
								</td>
								<td class="p-2 border border-solid d-theme-border-grey-light">
									{{ objectDetail.time_window_repeat.end_hour }}
								</td>
							</tr>
						</table>
					</div>
				</vx-card>
			</transition>
			<vs-divider />
			<h4 class="mb-4">{{ $t("TimeWindow.Schedule") }}</h4>
			<time-calendar
				ref="repeatCalendar"
				class="px-2"
				:viewData="true"
				:isMaximize="false"
				:cronExpression="objectDetail.cron"
				:duration="
					getDaysInRange(
						{
							startDate: objectDetail.time_window.init_date,
							endDate: objectDetail.time_window.end_date,
						},
						{
							start: objectDetail.time_window.init_hour,
							end: objectDetail.time_window.end_hour,
						}
					)
				"
			/>
		</div>
	</div>
</template>

<script>
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";
import TimeCalendar from "@/components/shared/TimeCalendar.vue";

export default {
	name: "DetailFormatRepeat",
	mixins: [generalPurposeMixin],
	components: {
		TimeCalendar,
	},
	props: {
		objectDetail: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
